document.addEventListener('DOMContentLoaded', function() {
  function replaceReviewTitle() {
    var title = document.querySelector('.jm-review-widget-minimal-header__title');
    if (title && title.tagName === 'P') {
      var h2 = document.createElement('h2');
      h2.className = title.className;
      h2.setAttribute('style', title.getAttribute('style') || '');
      Array.from(title.attributes).forEach(function(attr) {
        if (attr.name !== 'style' && attr.name !== 'class') h2.setAttribute(attr.name, attr.value);
      });
      h2.textContent = title.textContent;
      title.parentNode.replaceChild(h2, title);
    }
  }
  replaceReviewTitle();
  // Einmalige Fallbacks, falls Judge.me erst später lädt
  setTimeout(replaceReviewTitle, 1000);
  setTimeout(replaceReviewTitle, 2500);
});